import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private http: HttpClient) {}
  baseUrl = environment.baseUrl;

  createPayment(payload: any) {
    return this.http.post(`${this.baseUrl}/payment/createpayment`, payload);
  }
}
